module.exports = __webpack_public_path__ + "img/bgc3.5af42708.png";